<template>
  <div>
    <div class="edit-function">
      <!-- this.$router.push('/login') -->
      <!-- <el-button  @click="edit" v-if="deviceInfos.productStatus === '开发中' ">编辑</el-button> -->
       <el-button  @click="linkToEdit" v-if="deviceInfos.productStatus === '开发中' ">编辑</el-button>
    </div>
    <div class="infos">
      <el-row class="row-bg" justify="row-bg" :span="24">
        <el-col
          v-for="(item, key) in tableData"
          :key="key"
          :span="8">
          <el-col :span="9">
            {{key | modeTxt}}
          </el-col>
          <el-col :span="15">
            {{ key === "productSecret" && flag === true ? "******":item }}
            <i
              class="look"
              v-if="key == 'productSecret'"
              @click="look">
              {{ flag === true ? '查看' : '隐藏'}}
            </i>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="description">
        <el-col :span="3">
            产品描述
        </el-col>
        <el-col :span="5">
          {{productDescription}}
        </el-col>
      </el-row>

      <el-row class="description">
        <el-col :span="3">
            离线提示语
        </el-col>
        <el-col :span="5">
          {{offlineInstructions}}
        </el-col>
      </el-row>
      
    </div>

    <template v-if="deviceInfos.expandVo">

    <div class="edit-function">
      <el-button @click="expandEdit(2)" v-if="deviceInfos.productStatus === '开发中' ">编辑</el-button>
    </div>
    <div class="infos">
      <el-row class="row-bg" justify="row-bg" :span="24">
            <el-col
            v-for="(item, key) in tableData2"
              :key="key"
              :span="8">
              <el-col :span="9">
                {{key}}
              </el-col>
              <el-col   :span="15" class="ellipsis">
                {{ item }}
              </el-col>
            </el-col>
      </el-row>
      <el-row class="description">
        <el-col :span="3">
            协议文件
        </el-col>
        <el-col :span="5">
          <span v-if="downLoad.agreementFile"  class="loadBtn"  @click="download(downLoad.agreementFile)">下载</span>
        </el-col>
      </el-row>
    </div>

    <div class="edit-function">
      <el-button @click="expandEdit(3)" v-if="deviceInfos.productStatus === '开发中' ">编辑</el-button>
    </div>
    <div class="infos">
      <el-row class="description" style="line-height:50px;border-top: 1px solid #ecedee ">
        <el-col :span="3">
            产品小图
        </el-col>
        <el-col :span="5">
          <el-image v-if="smallPic" :src="smallPic" :preview-src-list="[smallPic]" style="width: 80px; height: 80px" alt="" srcset="" />
          <!-- {{agreementFile}} -->
        </el-col>
      </el-row>
      <el-row class="description">
        <el-col :span="3">
            产品规格书
        </el-col>
        <el-col :span="5">
            <div v-for="(item, index) in downLoad.specificationsUrl" :key="index">
              <span v-if="item.fileUrl" class="loadBtn"  @click="download(item.fileUrl)">{{item.fileName}}</span>
            </div>
        </el-col>
        <el-col :span="3">
            产品使用说明书
        </el-col>
        <el-col :span="5">

          <div v-for="(item, index) in downLoad.guideUrl" :key="index">
              <span v-if="item.fileUrl" class="loadBtn"  @click="download(item.fileUrl)">{{item.fileName}}</span>
            </div>
          <!-- <span  v-if="downLoad.guideUrl" class="loadBtn"   @click="download(downLoad.guideUrl)">下载</span> -->
        </el-col>
      </el-row>
      <!-- <el-row class="description">
        <el-col :span="3">
            产品说明书
        </el-col>
        <el-col :span="5">
          <span  class="loadBtn"   @click="download(downLoad.guideUrl)">下载</span>
        </el-col>
      </el-row> -->
    </div>

    <div class="edit-function">
      <!-- <el-button @click="expandEdit(4)" v-if="deviceInfos.productStatus === '开发中' ">编辑</el-button> -->
    </div>
    <div class="">
      <el-tabs v-model="activeName"  @tab-click="handleClick">
          <el-tab-pane label="产品图片" name="ios">
            <keep-alive>
              <el-row :span="24">
                <el-col :key="item.fileId" v-for="item in imageList.ios" :span="4" class="imgContent">
                  <el-tooltip :content="item.fileDesc" placement="top" effect="light">
                    <el-image style="width: 100px" :src="item.fileUrl" :preview-src-list="[item.fileUrl]" />
                  </el-tooltip>
                </el-col>
              </el-row>
            </keep-alive>
          </el-tab-pane>
          <!-- <el-tab-pane label="安卓" name="android">
             <keep-alive>
               <el-row :span="24">
                <el-col :key="item.fileId" v-for="item in imageList.android" :span="4" class="imgContent">
                  <el-tooltip :content="item.fileDesc" placement="top" effect="light">
                    <el-image style="width: 100px" :src="item.fileUrl" :preview-src-list="[item.fileUrl]" />
                  </el-tooltip>
                </el-col>
              </el-row>
             </keep-alive>
          </el-tab-pane>
          <el-tab-pane label="面板" name="panel">
            <keep-alive>
              <el-row :span="24">
                <el-col :key="item.fileId" v-for="item in imageList.panel" :span="4" class="imgContent">
                  <el-tooltip :content="item.fileDesc" placement="top" effect="light">
                    <el-image style="width: 100px" :src="item.fileUrl" :preview-src-list="[item.fileUrl]" />
                  </el-tooltip>
                </el-col>
              </el-row>
            </keep-alive>
          </el-tab-pane> -->
        </el-tabs>
    </div>
 </template>
    <el-dialog title="编辑产品" v-if="dialogFormVisible" :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="imgbox" width="800px"
      :append-to-body="true" >
      <el-form label-width="130px" ref="ruleForm"  :rules="rules" :model="form" style="margin-left:-48px">
        <el-form-item label="产品名称" prop="productName">
          <el-input v-model="form.productName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="节点类型"  :required="true">
          <el-input v-model="form.nodeType" disabled></el-input>
        </el-form-item>
        <el-form-item label="数据格式"  :required="true">
          <el-input v-model="form.dataFormat" disabled></el-input>
        </el-form-item>
        <el-form-item label="所属品类"  :required="true">
          <el-input v-model="form.categoryName" disabled></el-input>
        </el-form-item>
        <el-form-item label="产品标识符" prop="productKey">
          <el-input v-model="form.productKey" disabled></el-input>
        </el-form-item>
        <el-form-item label="认证方式" prop="authType">
          <el-select disabled v-model="form.authType" placeholder="请选择认证方式" style="width: 100%;">
            <el-option
              v-for="item in authTypeOptions"
              :key="item.authTypeKey"
              :label="item.authTypeName"
              :value="item.authTypeKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="连网协议"  :required="true">
          <el-input v-model="form.connectionType" disabled></el-input>
        </el-form-item>
        <el-form-item label="产品描述" prop="firmwareStatistics">
          <el-input type="textarea" v-model="form.productDescription" :rows="3" maxlength="100" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>

  <!-- 各个步骤对应的编辑 -->
  <addProductDialogStep1
    :productDetail="deviceInfos"
    :operate="operate"
    :currentStep="currentStep"
    v-if=" currentStep === 1"
    @closeDialog="closeDialog"/>

    <addProductDialogStep2
    :productDetail="deviceInfos"
    :brandOptions="brandOptions"
    :tagOptions="tagOptions"
    :expandDto="deviceInfos.expandVo"
    :currentStep="currentStep"
    :operate="operate"
    v-if="currentStep === 2"
    @delImg="delImg"
    @closeDialog="closeDialog"/>

     <addProductDialogStep3
     :operate="operate"
     :productDetail="deviceInfos"
     :expandDto="deviceInfos.expandVo"
     :currentStep="currentStep"
     v-if="currentStep === 3"
     @delImg="delImg"
      @closeDialog="closeDialog"/>

      <addProductDialogStep4
      :operate="operate"
       :expandDto="deviceInfos.expandVo"
      :productDetail="deviceInfos"
     :currentStep="currentStep"
     @delImg="delImg"
     v-if="currentStep === 4"
      @closeDialog="closeDialog"/>

  </div>
</template>

<script>
import { getListById, editProduct, getGroupCategory } from '@/api/productRegistration'
import addProductDialogStep1 from '@/components/product_control/addProductDialogStep1'
import addProductDialogStep2 from '@/components/product_control/addProductDialogStep2'
import addProductDialogStep3 from '@/components/product_control/addProductDialogStep3'
import addProductDialogStep4 from '@/components/product_control/addProductDialogStep4'
import eventBus from '@/assets/js/eventBus'
import { deleteProductFile } from '@/api/fileServer'
import { loadFileByUrl } from '@/utils'
export default {
  props: ['status'],
  components: {
    addProductDialogStep1,
    addProductDialogStep2,
    addProductDialogStep3,
    addProductDialogStep4
  },
  data () {
    return {
      deviceInfos: {},
      tableData: {},
      tableData2: {},
      tableData3: {},
      flag: true,
      dialogFormVisible: false,
      productDescription: '',
      offlineInstructions: '',
      form: {
        productName: '',
        nodeType: '',
        dataFormat: '',
        productCategory: '',
        connectionType: '',
        productDescription: '',
        offlineInstructions: ''
      },
      rules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ]
      },
      modeTxt2: {
        brandName: '产品品牌',
        accessType: '接入类型',
        productModel: '产品型号',
        signGroup: '分组标签',
        aliases: '产品别名',
        customerPhone: '客服电话',
        manufacturerName: '制造商',
        vendorPhone: '供应商电话',
        // agreementFile: '协议文件',
        // configNet: '配网方式'
      },
      modeTxt3: {
        smallPic: '产品小图',
        specificationsUrl: '产品规格书',
        guideUrl: '产品使用说明书'
      },
      modeTxt4: {
        smallPic: '产品小图',
        specificationsUrl: '产品规格书',
        guideUrl: '产品使用说明书'
      },
      downLoad: {
        agreementFile: '',
        specificationsUrl: '',
        guideUrl: ''
      },
      smallPic: '', // 产品小兔
      configNetList: {
        0: '二维码',
        1: '第三方SDK',
        2: '本地SDK'
      },
      accessTypeList: { // 接入类型
        0: 'MQTT',
        1: '云云对接'
      },
      activeName: 'ios',
      imageList: {
        ios: [],
        android: [],
        panel: []
      },
      currentStep: -1,
      operate: 'edit',
      dialogdialogFormVisible: false,
      brandOptions: [],
      tagOptions: [],
      delImgArr: [], // 保存用于删除的图片的token
      authTypeOptions: [
        {
          authTypeName: '设备密钥',
          authTypeKey: 0
        },
        {
          authTypeName: 'X.509证书',
          authTypeKey: 1
        }
      ]
    }
  },
  created () {
    /* if (localStorage.getItem('infos')) {
      this.deviceInfos = JSON.parse(localStorage.getItem('infos'))
    } else {
      this.deviceInfos = JSON.parse(this.$route.query.sRow)
    } */
    eventBus.$on('addDelImg', this.addDelImg)
    eventBus.$on('removeAgreement', this.removeAgreement)
  },
  watch: {
    status: {
      immediate: true,
      handler (val) {
        if (val === '1' || val === '2') this.getProductInfos()
      }
    },
    'deviceInfos.productStatus': {
      handler (val) {
        if (val === '已发布') {
          this.$store.commit('SET_PRODUCT_STATUS', true)
        } else {
          this.$store.commit('SET_PRODUCT_STATUS', false)
        }
      }
    }
  },
  async mounted () {
    await this.initSel()
    this.getProductInfos()
  },
  methods: {
    addDelImg (arr) {
      // this.delImgArr = this.delImgArr.concat(arr)
      console.log('删除的delImgArr：', this.delImgArr)
    },
    removeAgreement () {
      // 下载按钮隐藏
      this.downLoad.agreementFile = ''
    },
    delImg () {
      // 去重
      let imgArray = [...new Set(this.delImgArr)]
      imgArray = imgArray.filter(item => {
        return item !== ''
      })
      if (imgArray.length === 0) {
        return
      }
      deleteProductFile(imgArray).then(res => {
      }).catch(e => {
      })
      // 清空
      this.delImgArr.splice(0)
    },
    closeDialog (refresh) {
      console.log('refresh:', refresh)
      if (refresh) {
        this.getProductInfos()
      }
      this.currentStep = -1
    },
    download (path) {
      // window.open(path)
      debugger
      loadFileByUrl(path)
    },
    getProductInfos () {
      const params = {
        params: {
          productKey: JSON.parse(this.$route.query.sRow).productKey
        }
      }
      getListById(params).then(
        res => {
          sessionStorage.setItem('deviceNum', res.data.data.deviceNum)
          this.deviceInfos = res.data.data
          // from 表单desc展示
          let x = this.deviceInfos.expandVo;
          debugger;
          this.productDescription = this.deviceInfos.productDescription;
          this.offlineInstructions = this.deviceInfos.expandVo.offlineInstructions
          debugger;
          Object.keys(this.deviceInfos).forEach(item => {
            if (JSON.stringify(this.deviceInfos[item]) === 'null') {
              this.deviceInfos[item] = '---'
            }
            if (item === 'nodeType') {
              if (this.deviceInfos.nodeType === 0) {
                this.deviceInfos.nodeType = '直连设备'
              } else if (this.deviceInfos.nodeType === 1) {
                this.deviceInfos.nodeType = '网关子设备'
              } else {
                this.deviceInfos.nodeType = '网关设备'
              }
            }
            if (item === 'dataFormat') {
              if (this.deviceInfos.dataFormat === 0) {
                this.deviceInfos.dataFormat = 'ICA标准数据格式'
              } else {
                this.deviceInfos.dataFormat = '透传/自定义格式'
              }
            }
            if (item === 'authType') {
              if (this.deviceInfos.authType === 0) {
                this.deviceInfos.authType = 'secret'
              } else {
                this.deviceInfos.authType = 'X.509'
              }
            }
            if (item === 'productStatus') {
              if (this.deviceInfos.productStatus === 0) {
                this.deviceInfos.productStatus = '开发中'
              } else {
                this.deviceInfos.productStatus = '已发布'
              }
            }
            this.getConnecType(this.deviceInfos.connectionType)
          })
          // table展示
          // this.tableData.productKey = this.deviceInfos.productKey
          // this.tableData.productSecret = this.deviceInfos.productSecret
          // this.tableData.productName = this.deviceInfos.productName
          // this.tableData.categoryName = this.deviceInfos.categoryName
          // this.tableData.nodeType = this.deviceInfos.nodeType
          // this.tableData.connectionType = this.deviceInfos.connectionType
          // this.tableData.dataFormat = this.deviceInfos.dataFormat
          // this.tableData.authType = this.deviceInfos.authType
          // this.tableData.productStatus = this.deviceInfos.productStatus
          // this.tableData.deviceNum = this.deviceInfos.deviceNum
          // this.tableData.createTime = this.deviceInfos.createTime
          // this.tableData.updateTime = this.deviceInfos.updateTime
          const { productKey, productSecret, productName, categoryName, nodeType, connectionType, dataFormat, authType, productStatus, deviceNum, createTime, updateTime } = this.deviceInfos
          this.tableData = { productKey, productSecret, productName, categoryName, nodeType, connectionType, dataFormat, authType, productStatus, deviceNum, createTime, updateTime }
          console.log('this.tableData: ', this.tableData)
          console.log('this.deviceInfos: ', this.deviceInfos)
          // 原本的编辑弹窗
          this.sendDataToParent()
          delete this.deviceInfos.productDescription
          // this.form.productName = this.deviceInfos.productName
          // this.form.nodeType = this.deviceInfos.nodeType
          // this.form.dataFormat = this.deviceInfos.dataFormat
          // this.form.categoryName = this.deviceInfos.categoryName
          // this.form.connectionType = this.deviceInfos.connectionType
          // this.form.productDescription = this.productDescription
          // this.form.productKey = this.deviceInfos.productKey
          // this.form.authType = this.deviceInfos.authType === 'secret' ? 0 : 1
          // 优化：上面解构出来的变量
          this.form = { productName, nodeType, dataFormat, categoryName, connectionType, productKey }
          this.form.productDescription = this.productDescription
          this.form.authType = this.deviceInfos.authType === 'secret' ? 0 : 1
          debugger
          if (this.deviceInfos.expandVo) {
            // 扩展的数据
            const expandVo = this.deviceInfos.expandVo
            console.log('this.deviceInfos.expandVo', this.deviceInfos.expandVo)
            Object.keys(expandVo).forEach((key, index) => {
              if (this.modeTxt2[key]) {
                const chineseKey = this.modeTxt2[key]
                if (key === 'configNet') {
                  this.tableData2[chineseKey] = this.configNetList[expandVo[key]]
                } else if (key === 'accessType') {
                  this.tableData2[chineseKey] = this.accessTypeList[expandVo[key]]
                } else if (key === 'signGroup') {
                  // console.log('value:', this.accessTypeList[expandVo[key]])
                  if (expandVo[key]) {
                    const tagList = expandVo[key].split(',')
                    const tagNameList = []
                    this.tagOptions.map(item => {
                      if (tagList.indexOf(item.signId) > -1) {
                        tagNameList.push(item.signDesc)
                      }
                    })
                    this.tableData2[chineseKey] = tagNameList.join(',')
                  } else {
                    this.tableData2[chineseKey] = ''
                  }
                } else {
                  this.tableData2[chineseKey] = expandVo[key]
                }
              } else if (this.modeTxt3[key]) {
                const chineseKey = this.modeTxt3[key]
                this.tableData3[chineseKey] = expandVo[key]
              }
            })
            console.log('tableData2', this.tableData2)
            // 文件和图片
            // Object.assign(this.imageList, {
            //   ios: [],
            //   android: [],
            //   panel: []
            // })
            // 产品规格书
            const specificationsUrlFiles = []
            // 产品使用说明书
            const guideUrlFiles = []
            expandVo.fileLists.forEach((item, index) => {
              if (item.businessType.toString()) {
                if (item.businessType.toString() === '0') {
                  this.imageList.ios.push({
                    fileUrl: item.fileUrl,
                    fileDesc: item.fileDesc,
                    fileId: item.fileId
                  })
                } else if (item.businessType.toString() === '1') {
                  this.imageList.android.push({
                    fileUrl: item.fileUrl,
                    fileDesc: item.fileDesc
                  })
                } else if (item.businessType.toString() === '2') {
                  this.imageList.panel.push({
                    fileUrl: item.fileUrl,
                    fileDesc: item.fileDesc
                  })
                } else if (item.businessType.toString() === '3') {
                  this.downLoad.agreementFile = item.fileUrl
                } else if (item.businessType.toString() === '5') { // 产品规格说明书
                  item.name = item.fileName
                  item.url = item.fileUrl
                  specificationsUrlFiles.push(item)
                } else if (item.businessType.toString() === '6') { // 产品使用说明书
                  item.name = item.fileName
                  item.url = item.fileUrl
                  guideUrlFiles.push(item)
                }
              }
            })
            this.smallPic = expandVo.picUrl
            // this.downLoad.specificationsUrl = expandVo.specificationsUrl
            // this.downLoad.guideUrl = expandVo.guideUrl
            this.downLoad.specificationsUrl = specificationsUrlFiles
            expandVo.specificationsUrlFiles = specificationsUrlFiles

            this.downLoad.guideUrl = guideUrlFiles
            expandVo.guideUrlFiles = guideUrlFiles
            console.log('this.imageList:', this.imageList)
          }
        }
      )
    },
    // updata () {
    //   console.log(this.deviceInfos.productName)
    // },
    getConnecType (val) {
      switch (val) {
        case 1:
          this.deviceInfos.connectionType = 'WI-FI'
          break
        case 2:
          this.deviceInfos.connectionType = 'Zigbee'
          break
        case 3:
          this.deviceInfos.connectionType = '蓝牙'
          break
        case 4:
          this.deviceInfos.connectionType = '蜂窝(2G/3G/4G)'
          break
        case 5:
          this.deviceInfos.connectionType = '以太网'
          break
        case 6:
          this.deviceInfos.connectionType = 'LoRaWAN'
          break
        case 7:
          this.deviceInfos.connectionType = '其他'
          break
        default:
          break
      }
    },
    // 传值给父级
    sendDataToParent () {
      this.$emit('my-event', this.deviceInfos.productStatus, this.deviceInfos.deviceNum)
    },
    linkToEdit () {
      this.$router.push(
        { path: '/productControl/productEdit', query: { productKey: JSON.parse(this.$route.query.sRow).productKey } }
      )
    },
    edit (current) {
      this.dialogFormVisible = true
    },
    async expandEdit (current) {
      // 清空
      this.delImgArr.splice(0)
      this.currentStep = current
    },
    async initSel () {
      await getGroupCategory().then(res => {
        res = res.data
        if (res.code === 200) {
          this.tagOptions = res.data
          console.log('tagOptions', this.tagOptions)
        }
      }).catch(e => {

      })

      // return new Promise((resolve, reject) => {
      //   let getBrandFlag, getGroupFlag
      //   if (this.brandOptions.length === 0) {
      //     getBrandFlag = false
      //     getBrand().then(res => {
      //       getBrandFlag = true
      //       res = res.data
      //       if (res.code === 200) {
      //         this.brandOptions = res.data.map(item => {
      //           return {
      //             brandName: item.commonName ? item.commonName : item.brandName,
      //             brandId: item.brandId ? item.brandId : item.id
      //           }
      //         })
      //       }
      //     }).catch(e => {
      //       getBrandFlag = true
      //       if (getBrandFlag && getGroupFlag) {
      //         resolve()
      //       }
      //     })
      //   } else {
      //     getBrandFlag = true
      //   }
      //   if (this.tagOptions.length === 0) {
      //     getGroupFlag = false
      //     getGroupCategory().then(res => {
      //       getGroupFlag = true
      //       res = res.data
      //       if (res.code === 200) {
      //         this.tagOptions = res.data
      //       }
      //     }).catch(e => {
      //       getGroupFlag = true
      //       if (getBrandFlag && getGroupFlag) {
      //         resolve()
      //       }
      //     })
      //   } else {
      //     getGroupFlag = true
      //   }

      //   if (getBrandFlag && getGroupFlag) {
      //     resolve()
      //   }
      // })
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) { // 验证成功
          const expandDto = Object.assign({}, this.deviceInfos.expandVo)
          console.log('this.deviceInfos.expandVo', this.deviceInfos.expandVo)
          console.log('expandDto: ', expandDto)
          expandDto.fileLists = []
          const params = {
            params: {
              productKey: JSON.parse(this.$route.query.sRow).productKey,
              productName: this.form.productName,
              productDescription: this.form.productDescription,
              expandDto: expandDto
            }
          }
          // 字段名变化了，做相关处理
          // const expandVo =  this.deviceInfos.expandVo
          // const expandDto = Object.assign({}, expandVo)
          // delete expandDto.aliases
          // expandDto.alias = expandVo.aliases

          editProduct(params)
            .then(res => {
              if (res.data.code === 200) {
                // eventBus  传给父级
                eventBus.$emit('productName', res.data.data.productName)
                this.$message({
                  type: 'success',
                  message: '编辑成功'
                })
                this.getProductInfos()
                console.log('新的tabledata2！！', this.tableData2)
              }
            }).catch(err => {
              console.log(err)
              this.form.productName = this.deviceInfos.productName
            })
          this.dialogFormVisible = false
        } else {
          this.$message.error('请完善信息后再试')
        }
      })
    },
    // 重置
    close () {
      this.dialogFormVisible = false
    },
    look () {
      this.flag = !this.flag
    },
    handleClick () {

    }
  }
}
</script>

<style lang="less" scoped>
  .edit-function{
     margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
  }
  .infos{
    .loadBtn{
      color:#409EFF;
      cursor: pointer;
    }
    .row-bg{
      border-top: 1px solid #ecedee ;
      border-left: 1px solid #ecedee ;
      .el-col-8{
        border-bottom: 1px solid #ecedee ;
        border-right: 1px solid #ecedee ;
        .el-col-9{
          padding: 14px 12px;
          border-right: 1px solid #ecedee ;
          background: #fbfbfc;
        }
        .el-col-15{
          padding: 14px 12px;
        }
        .look{
          color: #0099FF;
          margin-left: 10px;
        }
        .look:hover{
          cursor:pointer;
        }
      }
    }
  }
  .description{
    border-left: 1px solid #ecedee ;
    border-bottom: 1px solid #ecedee ;
    border-right: 1px solid #ecedee ;
    .el-col-3,.el-col-5{
      padding: 14px 12px;
    }
    .el-col-3{
      border-right: 1px solid #ecedee ;
      background: #fbfbfc;
    }
  }
  .imgContent{
    text-align: center;
    vertical-align: middle;
    margin-bottom: 30px;
    img{
      width: 80%;
    }
  }
  .el-row{
    display: flex;
    flex-wrap: wrap;
  }
</style>
